import { CALL_API } from "../../middlewares/api";
import { allDepotsConst } from "../../states/transactions/Transactions.Helper";

export const TRANSACTIONS_LIST_GET_REQUEST = "TRANSACTIONS_LIST_GET_REQUEST";
export const TRANSACTIONS_LIST_GET_SUCCESS = "TRANSACTIONS_LIST_GET_SUCCESS";
export const TRANSACTIONS_LIST_GET_ERROR = "TRANSACTIONS_LIST_GET_ERROR";

export function get_transactions(from, to) {
  let uri =
    "/api/admin/transactions/systemdayrange" + "?From=" + from + "&To=" + to;

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        TRANSACTIONS_LIST_GET_REQUEST,
        TRANSACTIONS_LIST_GET_SUCCESS,
        TRANSACTIONS_LIST_GET_ERROR,
      ],
    },
  };
}

export function get_transactions_for_depot(depotId, from, to, investorId) {
  let uri =
    depotId === allDepotsConst
      ? "/api/admin/transactions/depotdayrange" +
        "?From=" +
        from +
        "&To=" +
        to +
        "&InvestorId=" +
        investorId +
        "&DepotId="
      : "/api/admin/transactions/depotdayrange" +
        "?From=" +
        from +
        "&To=" +
        to +
        "&DepotId=" +
        depotId +
        "&InvestorId=" +
        investorId;

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        TRANSACTIONS_LIST_GET_REQUEST,
        TRANSACTIONS_LIST_GET_SUCCESS,
        TRANSACTIONS_LIST_GET_ERROR,
      ],
    },
  };
}

export const TRANSACTION_LIST_CHANGE_PAGE = "TRANSACTION_LIST_CHANGE_PAGE";

export function change_transaction_list_page(page) {
  return (dispatch) => {
    dispatch({
      type: TRANSACTION_LIST_CHANGE_PAGE,
      page,
    });
  };
}

export const TRANSACTION_LIST_CHANGE_FILTER = "TRANSACTION_LIST_CHANGE_FILTER";

export function change_transaction_list_filter(key, value) {
  let filter = {};
  filter[key] = value;
  // Not used for now as transactions are only filtered with backend
  // Edit: not true, transactions are filtered per date in backend but other filters should be applied in fe
  return {
    type: TRANSACTION_LIST_CHANGE_FILTER,
    filter,
  };
}

export const TRANSACTION_FILTER_DATE_CHANGED =
  "TRANSACTION_FILTER_DATE_CHANGED";

export function change_transaction_list_filter_date(key, value) {
  return {
    type: TRANSACTION_FILTER_DATE_CHANGED,
    key,
    value,
  };
}
